import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
const buildDeleteSubmissionEndpoint = (forecastId, submissionTimestamp) => {
  return `forecasting/v1/submission/${forecastId}/submissionTimestamp/${submissionTimestamp}`;
};
export const deleteForecastSubmission = ({
  forecastSubmissionId,
  forecastSubmissionTimestamp
}) =>
// Error catching handled by consumer
http.delete(buildDeleteSubmissionEndpoint(forecastSubmissionId, forecastSubmissionTimestamp));
export const DELETE_FORECAST_SUBMISSION = registerQuery({
  fieldName: 'deleteForecastSubmission',
  args: ['forecastSubmissionId', 'forecastSubmissionTimestamp'],
  async fetcher({
    forecastSubmissionId,
    forecastSubmissionTimestamp
  }) {
    return await deleteForecastSubmission({
      forecastSubmissionId,
      forecastSubmissionTimestamp
    });
  }
});